import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, take, catchError } from "rxjs";
import { ContainerHubAndPark } from "./model/depots/ContainerHubAndPark";
import { HubType } from "./model/depots/HubType";

@Injectable({
    providedIn: 'root'
})

export class DepotManagementService {
    constructor(private httpClient: HttpClient) { }

    getContainerHubsByDivision(divisionId: number): Observable<ContainerHubAndPark[]> {
        return this.httpClient.get<ContainerHubAndPark[]>(`/api/container/containerhubsandparks/${divisionId}`)
            .pipe(take(1));
    }
}
